<nav class="nav__cont">
	<ul class="nav">
		<li class="nav__items" *ngFor="let option of options">
			<a
				class="nav-btn"
				[ngClass]="{ active: activeTab === option.tab_name }"
				(click)="selectTab(option.tab_name)"
			>
				<i class="{{ option.icon }} mr-1"></i> {{ option.text }}
			</a>
		</li>
	</ul>
</nav>

<!-- <ul *ngFor="let option of options" class="nav nav-pills nav-success mb-3" role="tablist">
    <li class="nav-item waves-effect waves-light" role="presentation">
        <a class="nav-link" data-bs-toggle="tab" role="tab" aria-selected="false" tabindex="-1" (click)="selectTab(option.tab_name)">{{option.text }}</a>
    </li>
   
  </ul> -->
